// Shown at /login — redirects to Okta for authentication
import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';

export const LoginPage = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      // Preserve the page the user was trying to reach. RequireAuth
      // navigates here with state.from = pathname; restoreOriginalUri in
      // App.jsx routes the user back there after Okta callback.
      const originalUri = location.state?.from || '/';
      oktaAuth.signInWithRedirect({ originalUri });
    }
  }, [authState, oktaAuth, location.state]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#1e1e23', flexDirection: 'column', gap: 24 }}>
      <img src="/logo-full.png" alt="xLight" style={{ height: 56, width: 'auto' }} />
      <p style={{ color: '#8888aa', fontSize: 12, letterSpacing: '0.08em' }}>REDIRECTING TO LOGIN...</p>
    </div>
  );
};

export default LoginPage;
